<template>
  <div>
      <v-layout wrap style="padding: 0 20px 0 20px;" v-if="values">
        <!--v-flex xs12 style="margin-bottom:20px">
          <center class="title" style="font-size:1.40rem !important;line-height:1.2;">{{data.Name}}</center>
          <center class="subtitle" style="font-size:15px">{{subtitle[locale]}}</center>
        </v-flex-->
        <v-flex xs12
          v-for="(item, ind) of values"
          :key="`${item.ID}`"
          :style="{'border-bottom': ind === values.length - 1 ? null :'1px solid #CCCCCC80', 'color': `${customTextColorContent ? customTextColorContent : ColorContent} !important`}"
        >
          <v-layout wrap align-center >

            <v-flex xs2 style="text-align: right;">
              <v-img :src="item.IMG"
                style="float:right;margin:10px;"
                width="40"
              />
            </v-flex>
            <v-flex xs7 align-center style="line-height:20px">
              <b>{{item.Name}}</b>
            </v-flex>
            <v-flex v-if="item.Value==='Correcto'" xs3 class="value" style="padding-right:20px;text-align: right;">
              <v-icon
                color="green darken-2"
              >
                mdi-check
            </v-icon>
            </v-flex>
            <v-flex v-else xs3 class="value" style="padding-right:20px;text-align: right;">
              {{item.Value}} {{item.Unit}}
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
  </div>
</template>

 <script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import constants from '@/constants'
  import utils from '@/services/utils'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
      customTextColorContent: {
        type: String,
        required: false,
        default: null
      },
    },
    data() {
      return {
        loading: false,
        hotelID: null,
        installationID: null,
        values: null,
        subtitle: { es: 'Control diario', en: 'Daily check', du: 'Täglicher Check' }
      }
    },
    computed: {
      ...mapState('app',['locale', 'ColorContent']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      }
    },
    watch: {
      'data.HsconsultingHotelID' (v) {
        this.getValues()
      },
      'data.HsconsultingInstallationID' (v) {
        this.getValues()
      }
    },
    mounted() {
      this.getValues()
    },
    methods: {
      getValues() {
        this.hotelID = this.data.HsconsultingHotelID
        this.installationID = this.data.HsconsultingInstallationID
        if (this.hotelID && this.installationID) {
          this.loading = true
          //const url = process.env.NODE_ENV === 'production' ? `https://hsconsulting.dviewcontent.com/public/hotels/${this.hotelID}/${this.installationID}` : `http://localhost:3802/public/hotels/${this.hotelID}/${this.installationID}`
          const url = `https://hsconsulting.dviewcontent.com/public/hotels/${this.hotelID}/${this.installationID}`
          axios.get(url)
          .then((response) => {
            this.values = response.data.map(item => {
              item.Name = utils.getTranslation(JSON.parse(item.Name), this.locale)
              return item
            })
            this.loading = false
          })
          .catch((error) => {
            // handle error
            console.log(error)
            this.loading = false
          })
        }

      }
    }
  }
</script>
